<div
    class="badge-toggle"
    [floatUi]="popper.content"
    [applyClass]="'market-header-bet-builder-signposting'"
    [appendTo]="tooltipAppendTo"
    [boundariesElement]="tooltipAppendTo"
    [hideOnScroll]="true"
    [hideOnClickOutside]="true"
    [arrowClass]="'popper-arrow'"
    [preventOverflow]="true"
    [class.badge-toggle-pressed]="isTooltipVisible()"
    (click)="toggleTooltip($event)"
    (onHidden)="closeTooltip()">
    {{ tooltipInfo.badgeText }}
</div>

<vn-popper-content #popper closeType="none" [cssClass]="hostClass">
    <ng-container content>
        <div class="market-header-bet-builder-tooltip">
            <div class="market-header-bet-builder-tooltip-header">
                <div class="market-header-bet-builder-tooltip-title-container">
                    <div class="market-header-bet-builder-tooltip-badge">{{ tooltipInfo.badgeText }}</div>
                    <div class="market-header-bet-builder-tooltip-title">{{ tooltipInfo.tooltipTitle }}</div>
                </div>
                <div class="close-button theme-ex" (click)="popperEl.close()"></div>
            </div>
            <div class="market-header-bet-builder-tooltip-content">{{ tooltipInfo.tooltipContent }}</div>
        </div>
    </ng-container>
</vn-popper-content>
